<template>
  <section class="">
    <div class="shadow p-3 rounded-lg bg-white mb-4">
      <h3 class="mb-2 font-semibold md:text-2xl text-lg">On Demand Classes</h3>
    </div>
    <VodLibrary :data="trainerSessionListData" />
  </section>
</template>

<script>
import VodLibrary from "@/components/VodLibrary.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { VodLibrary },
  data() {
    return {
      trainerSessionListData: [],
    };
  },
  computed: {
    ...mapGetters(["trainerSessionList"]),
  },
  async created() {
    this.getVodList();
  },
  methods: {
    ...mapActions([
      "getTrainerSessionList"
      ]),
    async getVodList() {
      let query = {
        page: 1,
      };
      await this.getTrainerSessionList({id: 1, query });
      this.trainerSessionListData = this.trainerSessionList.data.data.slice(0, 3);
    },
  },
};
</script>

<style></style>
